<template>
  <div class="other-segments">
    <div class="other-segments__info-box">
      <h2 class="other-segments__info-box--heading">Explore more options</h2>
      <p>
        <router-link
          :to="{ name: 'post', params: { slug: previousQuizLink } }"
        >Take the quiz</router-link> again, or select a different profile to see more results
      </p>
    </div>
    <router-link
      v-for="post in posts"
      :key="`post-${post.id}`"
      class="other-segments__segment-link link link--unstyled"
      :to="post.url"
    >
      <img
        v-if="post.featuredMedia"
        :src="post.featuredMedia[0].url"
        :alt="post.featuredMedia[0].alt || `${post.title} - image`"
        loading="lazy"
        class="other-segments__segment-image"
      >
      <h3
        class="other-segments__segment-title"
        v-html="post.title"
      />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'OtherSegments',
  props: {
    posts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    previousQuizLink() {
      return this.$attrs.quizSlug;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_other-segments';
</style>
